import { render, staticRenderFns } from "./InformationCardsSkeleton.vue?vue&type=template&id=9f7557c8&scoped=true"
import script from "./InformationCardsSkeleton.vue?vue&type=script&lang=js"
export * from "./InformationCardsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InformationCardsSkeleton.vue?vue&type=style&index=0&id=9f7557c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7557c8",
  null
  
)

export default component.exports